export const types = {
    // Sync
    SET_DEPARTMENTS: "SET_DEPARTMENTS",    
    SET_SELECTED_DEPARTMENT: "SET_SELECTED_DEPARTMENT",
    CLEAN_SELECTED_DEPARTMENT: "CLEAN_SELECTED_DEPARTMENT",
    CHANGE_DEPARTMENT: "CHANGE_DEPARTMENT",

    // Async    
    FETCH_DEPARTMENTS_ASYNC: "FETCH_DEPARTMENTS_ASYNC",        
};
